import { render, staticRenderFns } from "./ReturnSample.vue?vue&type=template&id=1c4efd5e&scoped=true"
import script from "./ReturnSample.vue?vue&type=script&lang=js"
export * from "./ReturnSample.vue?vue&type=script&lang=js"
import style0 from "./ReturnSample.vue?vue&type=style&index=0&id=1c4efd5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4efd5e",
  null
  
)

export default component.exports